import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FontResizerComponent } from '@frontend/sports/common/core/feature/font-resizer';
import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { SportsThemedSegmentedControlDirective } from '@frontend/sports/common/ui/sports-themed-segmented-control';
import { ValueSliderDirective } from '@frontend/sports/common/ui/value-slider';
import { CompetitionLogoComponent } from '@frontend/sports/competition-logos/feature';
import { NativePriceFormatterPipe } from '@frontend/sports/odds/feature/native-price';
import { DsSegmentedControlModule } from '@frontend/ui/segmented-control';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { TranslationToStringPipe } from '../cds/translation.pipe';
import { CrmPromotionContainerModule } from '../crm-promotion-container/crm-promotion-container.module';
import { ComponentProxyDirective } from '../deferred/component-proxy.directive';
import { DirectivesModule } from '../directives/directives.module';
import { EventDetailsCommonModule } from '../event-details-common/event-details-common.module';
import { GridModule } from '../grid/grid.module';
import { EventPickComponent } from '../option-pick/event-pick.component';
import { TabBarModule } from '../tab-bar/tab-bar.module';
import { EventLoadService } from './event-load.service';
import { ScoreboardShowcaseComponent } from './event-switcher/showcase-scoreboard.component';
import { TabsShowcaseComponent } from './event-switcher/showcase-tab-bar.component';
import { LiveAlertItemComponent } from './live-alert/live-alert-item.component';
import { LiveAlertListComponent } from './live-alert/live-alert-list.component';
import { LiveAlertManager } from './live-alert/live-alert-manager.service';
import { OptionGroupContainerComponent } from './option-group/option-group-container.component';
import { ShowcaseOptionGroupComponent } from './option-group/showcase-option-group.component';
import { ShowcaseMediaComponent } from './showcase-media/showcase-media.component';
import { ShowcaseComponent } from './showcase.component';
import { ShowcaseTrackingService } from './showcase.tracking.service';

@NgModule({
    imports: [
        CommonModule,
        TabBarModule,
        NgScrollbarModule,
        GridModule,
        CompetitionLogoComponent,
        TranslationToStringPipe,
        CrmPromotionContainerModule,
        DirectivesModule,
        EventDetailsCommonModule,
        ComponentProxyDirective,
        FontResizerComponent,
        ValueSliderDirective,
        ScrollAdapterComponent,
        EventPickComponent,
        NativePriceFormatterPipe,
        DsSegmentedControlModule,
        SportsThemedSegmentedControlDirective,
        IconCustomComponent,
    ],
    declarations: [
        LiveAlertItemComponent,
        LiveAlertListComponent,
        OptionGroupContainerComponent,
        ScoreboardShowcaseComponent,
        ShowcaseComponent,
        ShowcaseMediaComponent,
        ShowcaseOptionGroupComponent,
        TabsShowcaseComponent,
    ],
    exports: [ShowcaseComponent],
    providers: [EventLoadService, LiveAlertManager, ShowcaseTrackingService],
})
export class ShowcaseModule {}
